import React from 'react';
import { Images } from '../../../../utils/imageConstants';
import type { IScorerRequest } from '../types/request';

interface ScorerRequestCardProps {
  request: IScorerRequest;
  selected: boolean;
  onToggleSelect: () => void;
}

const currencySymbol: Record<string, string> = {
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£',
};

export const ScorerRequestCard: React.FC<ScorerRequestCardProps> = ({
  request,
  selected,
  onToggleSelect,
}) => {
  const name = request.name ?? '-';
  const fees = request.fees ?? 0;
  const currency = request.currency ?? 'INR';
  const symbol = currencySymbol[currency] ?? currency;
  const priceText = `Price/hr : ${symbol}${fees.toFixed(2)}`;

  const imageUri = request.imageUri;
  const cdnBaseUrl = import.meta.env.VITE_IMAGE_CDN_BASE_URL;
  const avatarSrc =
    imageUri && cdnBaseUrl
      ? `${cdnBaseUrl.replace(/\/$/, '')}/${imageUri.replace(/^\//, '')}`
      : Images.player_image;

  return (
    <div className={`staff-request-card ${selected ? 'selected' : ''}`}>
      <div className="staff-request-card-left">
        <div className="staff-request-card-avatar">
          <img src={avatarSrc} alt="" />
        </div>
        <div className="staff-request-card-content">
          <div className="staff-request-card-name">{name}</div>
          <div className="staff-request-card-price">{priceText}</div>
        </div>
      </div>
      <div className="staff-request-card-checkbox-wrap">
        <input
          type="checkbox"
          checked={selected}
          onChange={onToggleSelect}
          aria-label={`Select ${name}`}
        />
      </div>
    </div>
  );
};
